import { render, staticRenderFns } from "./SuppliersStockSold.vue?vue&type=template&id=379f3ee7&"
import script from "./SuppliersStockSold.vue?vue&type=script&lang=js&"
export * from "./SuppliersStockSold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports